import jwtDecode from 'jwt-decode'

export const decodeValidToken = (token) => {
  if (!token) {
    return { token: null, user: null }
  }

  try {
    const user = jwtDecode(token)
    const expiresAt = Number(user?.exp) * 1000

    if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
      return { token: null, user: null }
    }

    return { token, user }
  } catch (error) {
    return { token: null, user: null }
  }
}

export const readStoredSession = () => {
  const session = decodeValidToken(localStorage.getItem('token'))

  if (!session.token) {
    localStorage.removeItem('token')
  }

  return session
}
